<template>
  <div>
    <div class="header main">
      <div class="pull-left logo"></div>

      <div id="HeaderRight" class="pull-left header-menu">
        <div class="pull-left header-menu-left"></div>

        <div class="pull-left header-menu-child">
          <el-menu
            :default-active="activeMenu"
            mode="horizontal"
            :router="true"
            :background-color="'#ccf0ee'"
            :active-text-color="'#0b58a3'"
            :text-color="'#0b58a3'"
          >
            <el-menu-item index="" key="http://www.mdsyyey.com/">
              <a href='http://www.mdsyyey.com/' target='_self'>返回幼儿园首页</a>
            </el-menu-item>
            <el-menu-item index="/home">报名查询</el-menu-item>
            <el-menu-item index="/enrolment">新生报名</el-menu-item>
            <!-- <el-menu-item index="/parentingclass">亲子班报名</el-menu-item> -->
            <el-menu-item index="/controlcenter">我的报名</el-menu-item>
          </el-menu>
        </div>

        <div class="pull-right header-menu-right"></div>
      </div>

      <div class="Cle"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  & .logo {
    background: url(../../assets/images/Logo.jpg) no-repeat;
    height: 78px;
    width: 263px;
  }
  & .header-menu {
    padding-top: 15px;
    padding-left: 18px;
    & .header-menu-left {
      background: url(../../assets/images/Left.jpg) no-repeat;
      height: 44px;
      width: 18px;
    }
    & .header-menu-child {
      background: url(../../assets/images/MenuBackground.jpg);
      height: 44px;
      width: 1020px;
    }
    & .header-menu-right {
      background: url(../../assets/images/Right.jpg) no-repeat;
      height: 44px;
      width: 18px;
    }
  }

  & .el-menu--horizontal {
    & > .el-menu-item {
      height: 35px;
      line-height: 35px;
      margin: 0 38px;
      padding: 0 30px;
      &:focus,
      &:hover{
        background-color: transparent !important;
      }
    }
  }
  .el-menu.el-menu--horizontal{
    border-bottom: 0;
    margin-top: 9px;
  }
}
</style>